import React from "react";
import logo from "../../assets/logo.svg";
import { LogoImageProps } from "../../interfaces/props/LogoImageProps/LogoImageProps";

import classes from "./LogoImage.module.css";

export function LogoImage(props: LogoImageProps) {
  const { className = "", isMarkOnly = false } = props;
  const combinedClassName = `${classes.logoImage} ${
    isMarkOnly ? classes.logoImage_isMarkOnly : ""
  } ${className}`.trim();

  return (
    <img
      className={combinedClassName}
      src={logo}
      width={isMarkOnly ? 18 : 85}
      height="38"
      alt="Логотип ТатБГ"
    />
  );
}
